import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import componentObj from './dataset'

// @TODO: Add support notification(blue dots)
const Navigation = ({ selected, onClick }) => (
  <ul className="flex border-b text-primary-lightgray font-semibold px-3">
    {componentObj.map(({ title, value, iconSeparator, separator, textColor }, key) => (
      <Fragment key={key}>
        <li
          className={`p-3 md:p-5 cursor-pointer ${textColor || ''} ${selected === value && 'text-primary-orange border-b-2 border-primary-orange'}`}
          key={key}
          onClick={() => onClick(value)}
        >
          {title}
        </li>
        {(iconSeparator || separator) && <li className="flex items-center px-2">
          {iconSeparator && <i className={`${iconSeparator} text-4xl text-secondary-graywhite`} aria-hidden="true"></i>}
          {separator && <span className="text-4xl font-normal text-secondary-graywhite">{separator}</span>}
        </li>}
      </Fragment>
    ))}
  </ul>
)

Navigation.propTypes = {
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.string.isRequired,
}

export default Navigation
